import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Heart, Users, ShieldCheck, MapPin } from "lucide-react";

export default function Matches() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/matches").then(({ data }) => setMatches(data.matches || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#1A1A1A] text-[#F5F5F5]">
      <Navbar />

      <div className="max-w-5xl mx-auto px-6 sm:px-10 py-16">
        <span className="font-label text-[0.65rem] text-[#D4AF37]">Mutual</span>
        <h1 className="font-display text-5xl sm:text-6xl font-normal mt-3" data-testid="matches-title">
          Your <span className="italic text-[#D4AF37]">connections.</span>
        </h1>
        <p className="text-[#F5F5F5]/55 mt-3">Members who have also chosen you.</p>

        {loading ? (
          <div className="mt-16 text-center font-display text-2xl italic text-[#D4AF37]">Loading...</div>
        ) : matches.length === 0 ? (
          <div className="mt-16 goji-glass p-16 text-center" data-testid="matches-empty">
            <p className="font-display text-3xl italic">No mutual connections yet.</p>
            <p className="text-[#F5F5F5]/55 mt-2">Continue exploring introductions on Discover.</p>
          </div>
        ) : (
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#D4AF37]/15">
            {matches.map((m) => (
              <div key={m.match_id} className="bg-[#1A1A1A] overflow-hidden" data-testid={`match-card-${m.match_id}`}>
                <div className="relative">
                  <img
                    src={m.user.photo_url || "https://placehold.co/600x600/1A1A1A/D4AF37?text=Goji"}
                    alt={m.user.name}
                    className="w-full h-64 object-cover"
                  />
                  <span className="absolute top-3 right-3 px-2.5 py-1 bg-[#1A1A1A]/85 border border-[#D4AF37]/40 font-label text-[0.55rem] text-[#D4AF37]">
                    {m.mode === "dating" ? <><Heart className="inline w-2.5 h-2.5 mr-1" />Romance</> : <><Users className="inline w-2.5 h-2.5 mr-1" />Family</>}
                  </span>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2">
                    <h3 className="font-display text-2xl font-normal">{m.user.name}</h3>
                    {m.user.verified && (
                      <ShieldCheck className="w-3.5 h-3.5 text-[#D4AF37]" />
                    )}
                  </div>
                  {m.user.location && (
                    <p className="font-label text-[0.6rem] text-[#F5F5F5]/50 flex items-center gap-1 mt-2">
                      <MapPin className="w-3 h-3" /> {m.user.location}
                    </p>
                  )}
                  <p className="mt-4 text-sm text-[#F5F5F5]/70 italic line-clamp-2">"{m.user.bio}"</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
